import { MODERATION_REASONS } from "./moderationConstants";

const ModerationReasonsSelector = ({ selectedReasons, onAdd, onRemove }) => {
  return (
    <div className="mb-4 p-3 rounded" style={{ background: "#f8f9fa" }}>
      <label className="font-weight-bold mb-2" style={{ fontSize: 14 }}>
        Motifs pour modération - Optionnels
      </label>
      <p
        className="text-muted mb-2"
        style={{ fontSize: 13, fontStyle: "italic" }}
      >
        Ces motifs peuvent modifier la proposition de barème par défaut
      </p>

      <select
        className="form-control mb-3"
        value=""
        onChange={(e) => {
          if (e.target.value && !selectedReasons.includes(e.target.value)) {
            onAdd(e.target.value);
          }
        }}
        style={{ fontSize: 14 }}
      >
        <option value="">-- Ajouter un motif --</option>
        {Object.values(MODERATION_REASONS)
          .filter((reason) => !selectedReasons.includes(reason.id))
          .map((reason) => (
            <option key={reason.id} value={reason.id}>
              {reason.label}
            </option>
          ))}
      </select>

      {selectedReasons.length > 0 && (
        <div className="d-flex flex-wrap" style={{ gap: 8 }}>
          {selectedReasons.map((reasonId) => {
            const reason = MODERATION_REASONS[reasonId];
            return (
              <button
                key={reasonId}
                type="button"
                className="btn btn-sm btn-primary d-flex align-items-center"
                style={{ fontSize: 13, gap: 8 }}
                onClick={() => onRemove(reasonId)}
              >
                <span>{reason?.label || reasonId}</span>
                <i className="fa fa-times" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ModerationReasonsSelector;
